import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import { ThemeContext } from "../../context/ThemeProvider";
// import Kaorder from "./khiladiadda/KaOrder"
import Kacoupon from "./KaCoupon";

export default function Ka_coupon() {

  // theme context


  let navigate = useNavigate();


  return (
    <>
      {/* navigation section */}
      <section>
        <Sidebar />
        <Nabvar />
      </section>

      {/* body */}
      <section>
        <Kacoupon />
      </section>
    </>
  );
}
